import i18n from "@/plugins/i18n";

export function constructChartSeriesHeaderForTable(
  series,
  addTimestampColumn = false
) {
  const header = addTimestampColumn
    ? [{ text: i18n.t("common.timestamp"), value: "createdAt" }]
    : [];

  return header.concat(
    series.map((x) => {
      return { text: x.name, value: x.slotId.toString() };
    })
  );
}

export function constructChartSeriesDataForTable(series) {
  // Collects all datapoints in all series
  const allData =
    series.flatMap((x) =>
      x.data.map((y) => {
        return {
          time: y.value.at(0),
          value: y.value.at(1),
          serie: x.slotId,
        };
      })
    ) ?? [];

  // Sorts the datapoints by their timestamp. Combining several datapoints if they have the same timestamp
  const dataObject = {};
  for (var datapoint of allData) {
    if (dataObject[datapoint.time] === undefined)
      dataObject[datapoint.time] = {};

    dataObject[datapoint.time][datapoint.serie] = datapoint.value;
  }

  // Structures the data correctly for the table. Sets the timestamp as a value under createdAt
  return Object.entries(dataObject)
    .map((x) => {
      const row = x.at(1) ?? {};
      row.createdAt = new Date(x.at(0));
      return row;
    })
    .sort((a, b) => a.createdAt < b.createdAt);
}
